import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { definirMegaBonusGb } from "../../../backend/src/services/whatsapp/gerar-mensagem-proposta";

/**
 * Mega Bônus da convergência (Douglas 09/10/2026): o número é do banco e se troca
 * em Configurações → Produtos → Planos e Preços. Ao carregar, ele vai para a
 * memória que a proposta, o fechamento e o conversor de pedido leem.
 */
export type EstadoMegaBonus = {
  gb: number;
  alterado_em: string | null;
  alterado_por_nome: string | null;
  anterior_gb: number | null;
  pode_editar: boolean;
};

export const MEGA_BONUS_QUERY_KEY = ["mega-bonus"] as const;
const API_BASE = () => (import.meta.env.VITE_SUPABASE_URL as string) ?? "https://beta.crm-api.primetecia.com.br/api";

async function chamar(method: "GET" | "PUT", gb?: number): Promise<EstadoMegaBonus> {
  const { data: { session } } = await supabase.auth.getSession();
  const res = await fetch(`${API_BASE()}/v1/mega-bonus`, {
    method,
    headers: { Authorization: `Bearer ${session?.access_token ?? ""}`, ...(method === "PUT" ? { "Content-Type": "application/json" } : {}) },
    ...(method === "PUT" ? { body: JSON.stringify({ gb }) } : {}),
  });
  const json = await res.json().catch(() => null);
  if (!res.ok) throw new Error(json?.error || `o Mega Bônus respondeu ${res.status}`);
  return json.data as EstadoMegaBonus;
}

export function useMegaBonus() {
  return useQuery({
    queryKey: MEGA_BONUS_QUERY_KEY,
    staleTime: 60_000,
    refetchInterval: 60_000,
    queryFn: async () => {
      const estado = await chamar("GET");
      definirMegaBonusGb(estado.gb);
      return estado;
    },
  });
}

export function useTrocarMegaBonus() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (gb: number) => chamar("PUT", gb),
    onSuccess: (estado) => {
      definirMegaBonusGb(estado.gb);
      queryClient.setQueryData(MEGA_BONUS_QUERY_KEY, estado);
    },
  });
}
